import { render, staticRenderFns } from "./StudentItem.vue?vue&type=template&id=c677b622&"
import script from "./StudentItem.vue?vue&type=script&lang=js&"
export * from "./StudentItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports